import { render, staticRenderFns } from "./dashboardReclamos.vue?vue&type=template&id=396b51b0&"
import script from "./dashboardReclamos.vue?vue&type=script&lang=js&"
export * from "./dashboardReclamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports